// Constants for ItineraryPage

export const BUDGET_OPTIONS = [
  { value: 'low', label: 'Low Budget' },
  { value: 'medium', label: 'Medium Budget' },
  { value: 'high', label: 'High Budget' },
  { value: 'any', label: 'Any Budget' }
];

export const MONTH_OPTIONS = [
  { value: '', label: 'Any Month' },
  { value: 'january', label: 'January' },
  { value: 'february', label: 'February' },
  { value: 'march', label: 'March' },
  { value: 'april', label: 'April' },
  { value: 'may', label: 'May' },
  { value: 'june', label: 'June' },
  { value: 'july', label: 'July' },
  { value: 'august', label: 'August' },
  { value: 'september', label: 'September' },
  { value: 'october', label: 'October' },
  { value: 'november', label: 'November' },
  { value: 'december', label: 'December' }
];

export const TRANSPORTATION_OPTIONS = [
  { value: 'public', label: '🚌 Public Transport' },
  { value: 'own_car', label: '🚗 Own Car' },
  { value: 'rent', label: '🚙 Rent/Hire Car' },
  { value: 'mixed', label: '🔀 Mixed (Public + Car)' }
];

export const ITINERARY_TYPE_OPTIONS = [
  { value: '', label: 'Open to Anything' },
  { value: 'beach', label: '🏖️ Beach' },
  { value: 'mountain', label: '⛰️ Mountain' },
  { value: 'cultural', label: '🏛️ Cultural' },
  { value: 'historical', label: '🏺 Historical' },
  { value: 'adventure', label: '🧗 Adventure' },
  { value: 'nature', label: '🌲 Nature' },
  { value: 'culinary', label: '🍽️ Culinary' },
  { value: 'romantic', label: '💕 Romantic' },
  { value: 'family', label: '👨‍👩‍👧‍👦 Family' },
  { value: 'relax', label: '😌 Relax' },
  { value: 'party', label: '🎉 Party' },
  { value: 'solo', label: '🚶 Solo Travel' }
];

// Travel style cards for the visual selector on the form
export const TRAVEL_STYLE_OPTIONS = [
  {
    value: 'cultural',
    label: 'Cultural Deep Dive',
    description: 'Museums, heritage sites, and local traditions',
    image: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5?w=400&q=80',
  },
  {
    value: 'relax',
    label: 'Relaxed Escape',
    description: 'Beaches, spas, and scenic landscapes',
    image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&q=80',
  },
  {
    value: 'adventure',
    label: 'Adventure',
    description: 'Hiking, water sports, and adrenaline',
    image: 'https://images.unsplash.com/photo-1551632811-561732d1e306?w=400&q=80',
  },
];

